import {Button} from '@luminopia/react-toolbox/lib/button'
import SelectField from 'core/components/form/select-field'
import TextField from 'core/components/form/text-field'
import {createValidator, required} from 'core/validation'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Field, FormProps, getFormSubmitErrors, reduxForm} from 'redux-form'
import {FormError} from 'study_coordinator/components/FormError'
import { IState } from 'study_coordinator/store'
import {Link} from 'react-router-dom'
import * as styles from './deactivate-prescription-form.css'

interface ISubmit {
  reason: string
}

export interface IFormFields {
  deactivationReason: string
  otherReason: string
}

interface IComponentState {
  showOtherReason: boolean
}

interface IStateProps {
  initialValues?: Partial<IFormFields>
  formError?: string
}

interface IDispatchProps {
  onMount?: () => void
}

interface IOwnProps  {
  // TODO: The redux-form type for decorated component props is missing onSubmit, so declare it here
  onSubmit: (data: ISubmit) => void
  onCancel: () => void
}

export interface IProps extends
  IOwnProps,
  IDispatchProps,
  IStateProps,
  FormProps<IFormFields, IOwnProps, IComponentState> {}

const reasons = [
  'Error: patient details',
  'Error: duplicate Rx',
  'Patient paused',
  'Patient unresponsive',
  'Patient canceled',
  'Physician canceled',
  'Technical issue'
]

export class DeactivatePrescriptionForm extends React.PureComponent<IProps, IComponentState> {
  public state: IComponentState = {
    showOtherReason: false,
  }

  public render() {
    const {
      handleSubmit,
    } = this.props

    const deactivationReasons = {
      label: 'State reason for deactivation',
      options: [
        { label: 'Select' },
        ...reasons.map(reason => ({
          label: reason,
          value: reason,
        })),
        { label: 'Other', value: 'other' },
      ],
    }

    return (
      <div className={styles.container}>
        <form
          onSubmit={handleSubmit && handleSubmit((data) => (
            this.props.onSubmit({
              reason: data.otherReason || data.deactivationReason
            })
          ))}
        >
          {this.props.error && (<FormError>{this.props.error}</FormError>)}
          <Field name='deactivationReason' component={SelectField} props={deactivationReasons} onChange={(e: Event, val: string) => {this.setShowOtherReason(val === 'other')}} />
          {this.state.showOtherReason && (
            <Field name="otherReason" component={TextField} placeholder="Reason" />
          )}
          <Button
            type='submit'
            label='Confirm'
            raised
            primary
          />
          <Link to="#" onClick={this.props.onCancel}>cancel</Link>
        </form>
      </div>
    )
  }

  public componentDidMount() {
    if (this.props.onMount) this.props.onMount()
  }

  private setShowOtherReason = (val: boolean) => {
    this.setState({showOtherReason: val})
  }
}

export const deactivatePrescriptionFormFactory = (name: string) => {
  const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
    // TODO: redux-form types are incorrectly implemented. Remove the type cast after fixed
    const errors = getFormSubmitErrors(name)(state) as any
    const formError = errors && errors._error

    return {
      formError,
    }
  }

  const mapDispatchToProps = (dispatch: Dispatch<void>): IDispatchProps => ({
  })

  const formDecorator = reduxForm<IFormFields, IProps, IComponentState>({
    form: name,
    validate: (values, props) => {
      const validator = createValidator<typeof values>({
        deactivationReason: [required],
        otherReason: [(otherReason, data) => {
          return (data.deactivationReason === 'other' && !otherReason) ? 'Required' : undefined
        }]
      })
      return validator(values)
    },
    enableReinitialize: true,
  })

  // TODO: I'm not sure why the type of the component is not compatible. Instead of spending tons of time on this,
  // I'm going to just type this as any until we upgrade redux-form in the hopes that might solve the issue.
  const FormDecorated = formDecorator(DeactivatePrescriptionForm as any)

  return connect<IStateProps, IDispatchProps, IOwnProps, IState>(
    mapStateToProps,
    mapDispatchToProps,
  )(FormDecorated)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/subjects/deactivate-prescription-form.tsx